<template>
  <div id="blog" class="blog-wrap style1 pb-100">
    <div class="container">
      <div class="row section-margin">
        <div class="col-lg-8 col-md-12">
          <div class="section-title style1">
            <span>Blog &amp; News</span>
            <h2>Read Our Latest News & Articles</h2>
          </div>
        </div>
      </div>

      <Carousel
        :autoplay="5000"
        :wrap-around="true"
        :breakpoints="breakpoints"
        pause-autoplay-on-hover
        class="blog-slider-one"
      >
        <Slide v-for="blog in blogs" :key="blog.id">
          <div class="blog-card style1">
            <div class="blog-img"><img :src="blog.image" alt="Image" /></div>
            <div class="blog-info">
              <h3>
                <router-link to="/blog-details">
                  {{ blog.title }}
                </router-link>
              </h3>
              <ul class="blog-metainfo list-style">
                <li>
                  <i class="ri-calendar-event-fill"></i>
                  <a href="#">22 Mar, 2022</a>
                </li>
              </ul>
            </div>
          </div>
        </Slide>

        <template #addons>
          <Navigation />
        </template>
      </Carousel>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { Carousel, Slide, Navigation } from "vue3-carousel";

export default defineComponent({
  name: "LatestNews",
  components: {
    Carousel,
    Slide,
    Navigation,
  },
  data: () => ({
    settings: {
      itemsToShow: 1,
      snapAlign: "center",
    },
    blogs: [
      {
        id: 1,
        image: require("../../assets/images/blog/blog-1.jpg"),
        title: "Whatever You Do, Make Sure It Makes You Happy",
        date: "29 June, 2023",
      },
      {
        id: 2,
        image: require("../../assets/images/blog/blog-2.jpg"),
        title: "The Day I'd Spent At The Square Medical Facility",
        date: "28 June, 2023",
      },
      {
        id: 3,
        image: require("../../assets/images/blog/blog-3.jpg"),
        title: "The Success Of Treatment Of Stroke Patients Raises",
        date: "27 June, 2023",
      },
      {
        id: 4,
        image: require("../../assets/images/blog/blog-4.jpg"),
        title: "How Does Science Help In Dental Surgery Research",
        date: "26 June, 2023",
      },
    ],
    breakpoints: {
      0: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      768: {
        itemsToShow: 2,
        snapAlign: "start",
      },
      1200: {
        itemsToShow: 3,
        snapAlign: "center",
      },
    },
  }),
});
</script>